// import RoutingActions from '../../../actions/RoutingActions';
// import PosActions from '../../../actions/PosActions';
import PopupActions from '../../actions/PopupActions';
// import NotificationActions from '../../../actions/NotificationActions';
// import PosCartActions from '../../../actions/PosCartActions';
// import GuestActions from '../../../actions/GuestActions';

// import UserStore from '../../../stores/UserStore';
// import ConfigStore from '../../../stores/ConfigStore';
// import PosCartStore from '../../../stores/PosCartStore';
// import PosStore from '../../../stores/PosStore';

// import { endPoints as EndPoints } from '../../../constants/PosConstants';

class Loyalty extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            apply   : false,
            loyalty : false,
        };

        // this.onChange = this.onChange.bind(this);
    }

    render() {
        var guest                = this.props.guest;

        return (
            <div className='popup__content loyalty'>
                <div className='popup-header'>
                    VG CREDENTIALS ERROR

                    <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                </div>





            </div>
        );
    }
}

export default Loyalty;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/VGError.react.jsx